export default { sha: 'cca20f630a66fb5c0e8b78d1850ed967a4cf4261', buildNumber: 'undefined' }
